<div class="modal fade" id={{modelId}} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" id="modal">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row modal-heading-row">
                    <div class="row heading-row-right">
                        <img src="../../../../../assets/icons/logo.png" width="35px" height="32px"
                            class="d-inline-block align-top" alt="" loading="lazy" data-dismiss="modal">
                        <div class="modal-Heading">
                            Prefilled
                        </div>
                    </div>
                    <img src="../../../../../assets/icons/closeBlack.png" width="18px" height="18px"
                        style="cursor: pointer;" class="d-inline-block align-top" alt="" loading="lazy"
                        data-dismiss="modal">
                </div>
                <hr>
                <div>
                    <div class="modal-text">
                        Choose an outlet to prefilled
                    </div>
                    <form [formGroup]="outletForm" #data>
                        <div class="col-12" style="font-size: 14px;  margin-top: 25px; padding: 0">
                            <div class="form-group">
                                <select class="custom-select" style=" font-size: 14px;" id="inlineFormCustomSelect2"
                                    formControlName="shopName" (ngModelChange)="selectOutlet($event)" 
                                    [ngClass]="{ 'is-invalid': submitted && setWebshop.shopName.errors && activeAllOutlets.length > 0}">
                                    <option value='' selected>Choose...</option>
                                    <option *ngFor="let shop of activeAllOutlets; let i = index" [ngValue]="shop">
                                        {{shop.name}}</option>
                                </select>
                                <div *ngIf="submitted && setWebshop.shopName.errors" class="invalid-feedback">
                                    <div *ngIf="setWebshop.shopName.errors.required">Please select your shop</div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="col-md-12 modal-button-div">
                        <button class="btn modal-btn-delete-button" type="button" (click)="confirmPrefill()">
                            <span *ngIf="!loading">Confirm</span>
                            <div *ngIf="loading" style="position: absolute;">
                                <ngx-spinner bdColor="rgba(255,255,255,0)" size="small" color="#ffffff"
                                    type="ball-clip-rotate" [fullScreen]="false"></ngx-spinner>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>